import { commitRoot } from "../unova/commit";
import { PLACEMENT } from "../constants/const";
import { beginWork } from "../unova/unova";
import { Fiber } from "../types";
import { equals, requestAnimationFrameMod } from "../utils";

let workInProgress: Fiber | undefined;
let nextUnitOfWork: Fiber | undefined;

const workInProgressRoots: Fiber[] = [];

export const workQueue: Function[] = [];
let pending: boolean = false;

export function initTask(rootFiber: Fiber) {
  workInProgressRoots.push(rootFiber);
  startTransition(bridge);
}

function performUnitOfWork(currentFiber: Fiber): Fiber | undefined {
  beginWork(currentFiber);
  if (currentFiber.child) {
    return currentFiber.child;
  }

  while (currentFiber) {
    if (
      currentFiber.sibling &&
      !equals(currentFiber.sibling.child?.flag, PLACEMENT)
    ) {
      return currentFiber.sibling;
    }
    currentFiber = currentFiber.parent!;
  }
  return;
}

function flushQueue(): void {
  pending = true;
  while (workQueue.length > 0) {
    const work = workQueue.shift();
    work?.();
  }

  if (workQueue.length > 0) requestAnimationFrameMod(flushQueue);
  else pending = false;
}

export function startTransition(task: Function): void {
  workQueue.push(task);
  if (!pending) requestAnimationFrameMod(flushQueue);
}

function bridge(): void {
  if (nextUnitOfWork) {
    nextUnitOfWork = performUnitOfWork(nextUnitOfWork);
  }

  if (nextUnitOfWork) return startTransition(bridge);

  if (workInProgress) {
    commitRoot(workInProgress);
    workInProgress = undefined;
  } else {
    const workInProgressRoot = workInProgressRoots.shift();
    if (workInProgressRoot == undefined) return;

    nextUnitOfWork = workInProgressRoot;
    workInProgress = workInProgressRoot;

    return startTransition(bridge);
  }
}

export function scheduleUpdateOnFiber(oldFiber: Fiber): void {
  const newFiber = {
    ...oldFiber,
    alternate: oldFiber,
  };

  nextUnitOfWork = newFiber;
  workInProgress = nextUnitOfWork;
  startTransition(bridge);
}
